import jalaali from "jalaali-js";

export function convertToShamsiTime(dateString) {
  const date = new Date(dateString);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const timeString = `${hours}:${minutes}:${seconds}`;

  return `${timeString}`;
}

export function convertToShamsi(dateString) {
  const date = new Date(dateString);
  const jalaaliDate = jalaali.toJalaali(date);
  return `${jalaaliDate.jy}/${jalaaliDate.jm}/${jalaaliDate.jd}`;
}
